import React from 'react'
import { Box } from '@material-ui/core'
import { useStyles } from './CustomTable.styles'

interface CustomTableProps {
  headers: string[]
  rows: React.ReactNode[][]
  highlightLastRow?: boolean
  centerColumns?: number[]
}

const CustomTable = ({
  headers,
  rows,
  highlightLastRow = false,
  centerColumns = []
}: CustomTableProps) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <table className={classes.table}>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th
                key={header}
                className={`${classes.headerCell} ${
                  centerColumns.includes(index)
                    ? classes.centerCell
                    : ''
                }`}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => {
            const isLastRow = rowIndex === rows.length - 1
            const isHighlighted = highlightLastRow && isLastRow
            return (
              <tr
                key={rowIndex}
                className={`
                  ${isHighlighted ? classes.highlightRow : ''}
                  ${isLastRow ? classes.lastRow : ''}
                `}
              >
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={`${classes.cell} ${
                      centerColumns.includes(cellIndex)
                        ? classes.centerCell
                        : ''
                    }`}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
    </Box>
  )
}

export default CustomTable
